import React from 'react';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import ModalDialog from '../../../../Shared/ModalDialog';

interface EnterpriseContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const EnterpriseContactModal: React.FC<EnterpriseContactModalProps> = ({
  isOpen,
  onClose,
}) => {
  const handleContactNow = () => {
    window.location.href = '/member/support';
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onRequestClose={onClose}
      headerText="Enterprise Feature Access"
      contentLabelClassName="font-normal mt-0 mb-10 text-gray-900"
      subHeaderText={
        <div className="mb-4">
          Please contact your Success Team to gain access to this feature.
        </div>
      }
      className="max-w-xl p-8"
      topOffsetClass="top-1/2 transform -translate-y-1/2"
      subHeaderTextClassName="text-base text-gray-900"
      contentLabelContainerClassName="space-y-0"
      closeButtonClassName="text-gray-700 font-light"
    >
      <div className="flex gap-3 justify-end">
        <Button variant="outlined-dark" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleContactNow}>Contact Now</Button>
      </div>
    </ModalDialog>
  );
};

export default EnterpriseContactModal;
